import { render, staticRenderFns } from "./IconRootSetting.vue?vue&type=template&id=ebb26a74&scoped=true"
import script from "./IconRootSetting.vue?vue&type=script&lang=js"
export * from "./IconRootSetting.vue?vue&type=script&lang=js"
import style0 from "./IconRootSetting.vue?vue&type=style&index=0&id=ebb26a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb26a74",
  null
  
)

export default component.exports